import { PropsWithChildren } from 'react';
import { LDProvider } from 'launchdarkly-react-client-sdk';

import { useConfig } from '@/shared/contexts/config';
import { InternalProvider } from '@/shared/contexts/launch-darkly/InternalProvider';

export const LaunchDarklyProvider = ({ children }: PropsWithChildren) => {
  const { appName, launchDarklyId } = useConfig();
  const isAdminConsole = appName === 'adminconsole';

  if (!launchDarklyId || isAdminConsole) {
    return <InternalProvider>{children}</InternalProvider>;
  }

  return (
    <LDProvider clientSideID={launchDarklyId}>
      <InternalProvider>{children}</InternalProvider>
    </LDProvider>
  );
};
